import { Directive, ElementRef, Renderer2, AfterViewInit, OnDestroy } from '@angular/core';

@Directive({
	selector: '[appMultiline]'
})
export class MultilineDirective implements AfterViewInit, OnDestroy {
	private observer: MutationObserver;

	constructor(private el: ElementRef, private renderer: Renderer2) { }

	ngAfterViewInit() {
		this.checkMultiline(); // 初次驗證

		// 建立 observer 監控節點與文字變化
		this.observer = new MutationObserver(() => {
			this.checkMultiline();
		});

		this.observer.observe(this.el.nativeElement, {
			characterData: true,
			childList: true,
			subtree: true,
		});
	}

	//（可選）監聽視窗尺寸變化
	ngOnDestroy() {
		if (this.observer) {
			this.observer.disconnect();
		}
	}

	private checkMultiline() {
		const element = this.el.nativeElement;
		const computedStyle = window.getComputedStyle(element);

		// 部分多行出現 NaN 概率處理
		let lineHeight = parseFloat(computedStyle.lineHeight);
		if (isNaN(lineHeight)) {
			// 若get不到行高，就用字體大小 fallback
			lineHeight = parseFloat(computedStyle.fontSize) * 1.2;
		}

		const lineCount = Math.round(element.scrollHeight / lineHeight);

		this.renderer.removeClass(element, 'is-multiline');
		if (lineCount > 1) {
			this.renderer.addClass(element, 'is-multiline');
		}
	}
}
